// extracted by mini-css-extract-plugin
module.exports = {"chat__inputWrapper":"ChatInput_chat__inputWrapper_17LYI","chat__input":"ChatInput_chat__input_3HBz3","chat__label":"ChatInput_chat__label_34LfA"};